module.exports = __webpack_public_path__ + "static/media/uz.2627db26.svg";